var map = {
  "./da.json": [
    "404149",
    "5158"
  ],
  "./fi.json": [
    "600559",
    "8164"
  ],
  "./sv.json": [
    "510991",
    "3412"
  ],
  "./ja.json": [
    "303979",
    "1016"
  ],
  "./zh-HK.json": [
    "967462",
    "4411"
  ],
  "./customer/fi.json": [
    "919066",
    "2519"
  ],
  "./fr.json": [
    "675222",
    "2795"
  ],
  "./es-419.json": [
    "471625",
    "7602"
  ],
  "./es.json": [
    "418302",
    "3907"
  ],
  "./customer/nl.json": [
    "341062",
    "2850"
  ],
  "./no.json": [
    "669093",
    "7686"
  ],
  "./en.json": [
    "210389",
    "5126"
  ],
  "./zh.json": [
    "499872",
    "6089"
  ],
  "./customer/en.json": [
    "529984",
    "1033"
  ],
  "./pt-BR.json": [
    "693085",
    "6846"
  ],
  "./nl.json": [
    "926920",
    "6577"
  ],
  "./pt-PT.json": [
    "878561",
    "106"
  ],
  "./customer/it.json": [
    "602014",
    "4355"
  ],
  "./customer/de.json": [
    "102596",
    "4453"
  ],
  "./customer/sv.json": [
    "830522",
    "8087"
  ],
  "./customer/fr.json": [
    "555651",
    "8928"
  ],
  "./de.json": [
    "290369",
    "8778"
  ],
  "./it.json": [
    "734895",
    "7204"
  ],
  "./customer/es.json": [
    "730999",
    "8236"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 918936;
module.exports = __rspack_async_context;
